import { state } from '../Components/Context';

export const isLastCheck = (state: state) => {
  return state.flow.length - 2 === state.current.order; // -2 because we're not counting the success screen.
}